/* The page's own words and destinations, for whichever Mirror this is (from window.MirrorEra, written by the section). */
(function(){
  const era=window.MirrorEra||{},product=window.ViuletJourneyProduct||{};
  const print=era.print||{},w=Number(print.width)||20,h=Number(print.height)||20;
  const n=value=>String(Math.round(value*100)/100);
  window.VIULET_PRODUCT_PAGE={
    id:era.handle,title:era.title,artist:era.artist||'Benjamin Viulet',
    editionLabel:era.edition?'Edition of '+String(era.edition).trim():'',
    currency:window.ViuletJourneyCurrency,
    startingPrice:(Number(product.price_min)||0)/100,
    oracleUrl:'/pages/oracle',collectionUrl:'/collections/mirrors',contactUrl:'/pages/contact',
    artworkUrl:'/products/'+era.handle,
    // Said aloud with the framed artwork: "20 inches square", or "25 by 20 inches".
    printLabel:print.known===false?'':w===h?n(w)+' inches square':n(w)+' by '+n(h)+' inches',
    detailViews:(Array.isArray(era.details)?era.details:[]).map(view=>({
      id:view.id,label:view.label,title:view.title,description:view.description,
      x:Number(view.x),y:Number(view.y),zoom:Number(view.zoom)||2
    }))
  };
})();
